import { useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n0 } from "../../lib/format";
import { Notice, Pager } from "../../lib/ui";

/*
 * Inventory stock report – port of stockanalytics.php (API: GET /api/stock/availability-percent)
 * Available % = quantity ÷ minimum stock × 100, lowest first, 12 per page.
 * Green ≥ 50 %, amber ≥ 30 %, red below. Products with no minimum set are labelled instead of shown as 0 %.
 */

const PER = 12;
const band = (r) => (!r.has_minimum ? "none" : r.available_percent >= 50 ? "ok" : r.available_percent >= 30 ? "warn" : "err");
const BG = { ok: "#f0fbf4", warn: "#fff9ea", err: "#fdf1f3", none: undefined };

export default function StockAvailability() {
  const api = useApi();
  const [term, setTerm] = useState("");
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(null);
  const [page, setPage] = useState(1);
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/stock/availability-percent", { search }).then((r) => { setRows(r); setPage(1); }).catch((e) => setError(e.message)); }, [api, search]);
  const pages = Math.max(1, Math.ceil((rows?.length || 0) / PER));
  const shown = (rows || []).slice((page - 1) * PER, page * PER);
  return (
    <main className="pg">
      <PageHeader slug="stockanalytics" />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel">
        <form className="toolbar" onSubmit={(e) => { e.preventDefault(); setSearch(term.trim()); }}>
          <div className="field grow"><div className="search"><i className="fas fa-magnifying-glass" />
            <input value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Search product" aria-label="Search product" /></div></div>
          <button type="submit" className="btn primary">Search</button>
          <span style={{ alignSelf: "center", fontSize: ".78rem", color: "var(--muted)" }}>
            <span className="pill-tag ok">≥ 50%</span> <span className="pill-tag warn">30–49%</span> <span className="pill-tag err">&lt; 30%</span></span>
        </form>
        <div className="tbl-wrap">
          <table className="tbl">
            <thead><tr><th>#</th><th>Product</th><th className="num">Quantity</th><th className="num">Minimum stock</th><th className="num">Available</th></tr></thead>
            <tbody>
              {shown.map((r, i) => {
                const b = band(r);
                return (
                  <tr key={`${r.product_name}-${i}`} style={{ background: BG[b] }}>
                    <td>{(page - 1) * PER + i + 1}</td><td style={{ fontWeight: 600, color: "var(--ink)" }}>{r.product_name}</td>
                    <td className="num mono">{n0(r.quantity)}</td><td className="num mono">{n0(r.minimum_stock)}</td>
                    <td className="num">{r.has_minimum ? <span className={`pill-tag ${b}`}>{r.available_percent.toFixed(2)}%</span> : <span className="pill-tag">No minimum set</span>}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {rows && rows.length === 0 && <div className="empty"><i className="fas fa-magnifying-glass" />No products found.</div>}
        </div>
        <Pager page={page} totalPages={pages} onPage={setPage} />
      </section>
    </main>
  );
}
